import { render, staticRenderFns } from "./unreadNotificationsCount.vue?vue&type=template&id=67fe392b"
import script from "./unreadNotificationsCount.vue?vue&type=script&lang=js"
export * from "./unreadNotificationsCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/francescobarbieri/Dev/brain/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67fe392b')) {
      api.createRecord('67fe392b', component.options)
    } else {
      api.reload('67fe392b', component.options)
    }
    module.hot.accept("./unreadNotificationsCount.vue?vue&type=template&id=67fe392b", function () {
      api.rerender('67fe392b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/admin-panel/components/sidebar/unreadNotificationsCount.vue"
export default component.exports